import ApiManager from '../api/crud-manager';

class RealTimeStock {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="RealTimeStock"]'),
      availableModule: el => el.querySelector('[data-stock-available]'),
      notAvailableModule: el => el.querySelector('[data-stock-not-available]'),
      limitedModule: el => el.querySelector('[data-stock-limited]'),
      quoteModule: el => el.querySelector('[data-stock-quote]'),
      loaderModule: el => el.querySelector('[data-stock-loader]'),
      errorModule: el => el.querySelector('[data-stock-error]'),
      apiManager: new ApiManager(),
      ...options
    };
  }

  async handleApiCall(module) {
    const { productId, minAmount, stockColor } = module.dataset;

    if (productId) {
      const stockResponse = await this.config.apiManager.get(
        `/api/v2/catalog/product/${productId}/stock`
      );

      const loader = this.config.loaderModule(module);
      loader.classList.remove('is-loading');
      if (stockResponse !== null) {
        const { amountInStock } = stockResponse;
        let stateKey = '';

        if (stockColor.length) {
          if (stockColor.toLowerCase() === 'red') {
            stateKey = 'not-available';
          } else if (stockColor.toLowerCase() === 'orange') {
            stateKey = 'limited';
          } else if (stockColor.toLowerCase() === 'purple') {
            stateKey = 'quote';
            const priceDiv = document.querySelectorAll(`#price_${productId}`);
            const usedProducts = [];
            Array.from(priceDiv)
              .reverse()
              .forEach(item_ => {
                const item = item_;
                if (usedProducts.indexOf(item.id) === -1) {
                  usedProducts.push(item.id);
                  item.innerHTML = module.dataset.priceError;
                } else {
                  item.innerHTML = '';
                }
              });
          } else {
            stateKey = 'available';
          }
        } else if (amountInStock && amountInStock > 0 && amountInStock > minAmount) {
          stateKey = 'available';
        } else {
          stateKey = 'limited';
        }

        let el;
        if (stateKey === 'available') {
          el = this.config.availableModule(module);
        } else if (stateKey === 'not-available') {
          el = this.config.notAvailableModule(module);
        } else if (stateKey === 'limited') {
          el = this.config.limitedModule(module);
        } else if (stateKey === 'quote') {
          el = this.config.quoteModule(module);
        }
        el.classList.remove('hidden');
      } else {
        const el = this.config.errorModule(module);
        el.classList.remove('hidden');
      }
    }
  }

  init() {
    const { moduleList } = this.config;
    moduleList.forEach(module => {
      this.handleApiCall(module);
    });
  }
}

export default RealTimeStock;
